export const SUCCESS_SLIDE_DETAILS = "SUCCESS_SLIDE_DETAILS";
export const LOADING_SLIDE_DETAILS = "LOADING_SLIDE_DETAILS";
export const SUCCESS_MULTIPLE_SLIDES_DATA = "SUCCESS_MULTIPLE_SLIDES_DATA";
export const SUCCESS_DOWNLOAD_DECK = "SUCCESS_DOWNLOAD_DECK";
